import { Trophy, Users, TrendingUp, TrendingDown } from "lucide-react";
import type { FantasyLeaderboardStats } from "@/types/api.types";

export default function FantasyLeaderboardStatsCard({
  stats,
}: {
  stats: FantasyLeaderboardStats;
}) {
  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-2">
      <div className="bg-white rounded-xl border p-4 flex items-center gap-3">
        <div className="p-2 bg-blue-100 rounded-lg">
          <Users className="h-5 w-5 text-blue-600" />
        </div>
        <div>
          <p className="text-2xl font-bold text-gray-900">{stats.totalTeams}</p>
          <p className="text-xs text-gray-500">Total Teams</p>
        </div>
      </div>

      <div className="bg-white rounded-xl border p-4 flex items-center gap-3">
        <div className="p-2 bg-green-100 rounded-lg">
          <TrendingUp className="h-5 w-5 text-green-600" />
        </div>
        <div>
          <p className="text-2xl font-bold text-gray-900">
            {stats.highestPoints}
          </p>
          <p className="text-xs text-gray-500">Highest Points</p>
        </div>
      </div>

      <div className="bg-white rounded-xl border p-4 flex items-center gap-3">
        <div className="p-2 bg-purple-100 rounded-lg">
          <Trophy className="h-5 w-5 text-purple-600" />
        </div>
        <div>
          <p className="text-2xl font-bold text-gray-900">
            {stats.averagePoints}
          </p>
          <p className="text-xs text-gray-500">Average Points</p>
        </div>
      </div>

      <div className="bg-white rounded-xl border p-4 flex items-center gap-3">
        <div className="p-2 bg-orange-100 rounded-lg">
          <TrendingDown className="h-5 w-5 text-orange-600" />
        </div>
        <div>
          <p className="text-2xl font-bold text-gray-900">
            {stats.lowestPoints}
          </p>
          <p className="text-xs text-gray-500">Lowest Points</p>
        </div>
      </div>

      {stats.topTeam && (
        <div className="col-span-2 md:col-span-4 bg-gradient-to-r from-yellow-50 to-orange-50 border border-yellow-200 rounded-xl p-4 flex items-center gap-3">
          <span className="text-2xl">👑</span>
          <div>
            <p className="font-bold text-gray-900">{stats.topTeam.name}</p>
            <p className="text-sm text-gray-600">
              by <span className="font-medium">@{stats.topTeam.owner}</span> ·{" "}
              <span className="text-yellow-700 font-bold">
                {stats.topTeam.points} pts
              </span>
            </p>
          </div>
          <div className="ml-auto">
            <span className="text-xs bg-yellow-200 text-yellow-800 px-2 py-1 rounded-full font-bold">
              🏆 #1 Team
            </span>
          </div>
        </div>
      )}
    </div>
  );
}
